// Module
var code = "<div class=\"back-navigation\" data-ng-click=\"goBack()\"> <div class=\"back-border\"> <i class=\"vngage-icon-left-open-big\"></i> </div> </div>";
// Exports
var _module_exports =code;;
var path = 'common/vngageBackNavigation/vngageBackNavigationTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;